export const BaseLineWorld = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.0004 15.8402C17.3023 15.8402 21.6004 14.1209 21.6004 12.0002C21.6004 9.87937 17.3023 8.16016 12.0004 8.16016C6.69845 8.16016 2.40039 9.87937 2.40039 12.0002C2.40039 14.1209 6.69845 15.8402 12.0004 15.8402Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.44"
    />
    <path
      d="M15.8402 11.9999C15.8402 17.3018 14.1209 21.5999 12.0002 21.5999C9.87937 21.5999 8.16016 17.3018 8.16016 11.9999C8.16016 6.69797 9.87937 2.3999 12.0002 2.3999C14.1209 2.3999 15.8402 6.69797 15.8402 11.9999Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.44"
    />
    <path
      d="M12.0004 21.5999C17.3023 21.5999 21.6004 17.3018 21.6004 11.9999C21.6004 6.69797 17.3023 2.3999 12.0004 2.3999C6.69846 2.3999 2.40039 6.69797 2.40039 11.9999C2.40039 17.3018 6.69846 21.5999 12.0004 21.5999Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.44"
    />
  </svg>
);
